import ParamUtils from '../utils/index';
import Web3_1_0 from '../utils/Web3_1_0';

/**
 * ParamSubscriber is an implementation of core param protocol, using this class user can able to subscriber the post into ParamNetwork. 
 * 
 */
class ParamSubscriber {
    /**
     * Default constructor for initialising or establishing the param subscriber.
     * @param {ParamNetwork} _paramNetwork Object
     */
    constructor(_paramNetwork, contractAddress) {
        this.connection = _paramNetwork.getConnection();
        const paramSubscriberManager = require('./param-subscriber.json')
        // this.paramSubscriberManagerContract = new this.connection.eth.Contract(paramSubscriberManager.abi, contractAddress);
        // this.paramSubscriberManagerContract = this.paramSubscriberManagerContract.at(paramSubscriberManager.address);
        this.paramSubscriberManagerContract = Web3_1_0.getContract(this.connection, paramSubscriberManager.abi, contractAddress ? contractAddress : paramSubscriberManager.address);

        this.to = paramSubscriberManager.address;
    }

    /**
     * initEvents is a event listener used for listening the real time changes whenever a receipt is subscribed.
     * @param {JSON} options - {"address":"0x"}
     * @example 
     * Usage:
     *  paramSubscriberManager
     *   .initEvents({address:'0x'})
     *   .then((result)=>{
     *       //TODO 
     *   })
     */

    initEvents(options) {
        let events = require('events');
        this.events = new events.EventEmitter();

        if (!options || !options.address) {
            console.log("Options are getting empty. So unable to register the events...")
            return;
        }

        if (options) {
            options = { owner: options.address };
        }
        this.watchAddConsentEvent(options);

        this.watchAddSubscriberEvent(options);
    }

    emitEvent(eventName, eventJSON) {
        Web3_1_0.upgradeEventData(eventJSON, this.connection).then(event => {
            this.events.emit(eventName, null, event);
        })
    }
    watchAddConsentEvent(options) {
        if (typeof this.addConsentEvent === 'undefined' || !this.addConsentEvent) {
            // this.addConsentEvent = this.paramSubscriberManagerContract.events.onConsent();
            this.addConsentEvent = Web3_1_0.getEvent(this, this.paramSubscriberManagerContract, "onConsent");
        }
        let that = this;
        this.addConsentEvent.on('data', function (event) {
            that.emitEvent("onConsent", event);
        })
            .on('error', function (error) {
                that.events.emit("onConsent", error);
                that.addConsentEvent.unsubscribe();
                that.addConsentEvent = undefined;
                that.watchAddConsentEvent(options);
            });
    }

    watchAddSubscriberEvent(options) {
        if (typeof this.addSubscriberEvent === 'undefined' || !this.addSubscriberEvent) {
            // this.addSubscriberEvent = this.paramSubscriberManagerContract.events.onSubscriber();
            this.addSubscriberEvent = Web3_1_0.getEvent(this, this.paramSubscriberManagerContract, "onSubscriber");
        }
        let that = this;
        that.addSubscriberEvent.on('data', function (event) {
            that.emitEvent("onSubscriber", event);
        }).on('error', function (error) {
            that.events.emit("onSubscriber", error);
            that.addSubscriberEvent.unsubscribe();
            that.addSubscriberEvent = undefined;
            that.watchAddSubscriberEvent(options);
        });
    }

    addSellerConsent(receiptId, receiptType, docContractAddress, options) {
        return Web3_1_0.send(this, this.paramSubscriberManagerContract, "addSellerConsent", options, receiptId, receiptType, docContractAddress);
    }

    addBuyerConsent(receiptId, receiptType, docContractAddress, options) {
        return Web3_1_0.send(this, this.paramSubscriberManagerContract, "addBuyerConsent", options, receiptId, receiptType, docContractAddress);
    }

    addSubscriber(payload, receiptId, receiptType, subscriber, docContractAddress, options) {
        return Web3_1_0.send(this, this.paramSubscriberManagerContract, "addSubscriber", options, payload, receiptId, receiptType, subscriber, docContractAddress);
    }

    addSubscriberForCons(payload, receiptId, receiptType, subscriber, docContractAddress, seller, buyer, options) {
        return Web3_1_0.send(this, this.paramSubscriberManagerContract, "addSubscriberForCons", options, payload, receiptId, receiptType, subscriber, docContractAddress, seller, buyer);
    }
    
    getConsentsForReceipt(receiptId) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "getConsentsForReceipt", null, receiptId);
    }

    getSubscribers(receiptId) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "getSubscribers", null, receiptId);

    }

    getSubscriber(sId) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "getSubscriber", null, sId);
    }

    getSubscriberReceipts(owner) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "getSubscriberReceipts", null, owner);
    }
    
    isSubscriberExists(receiptId, subscriberAddress) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "isSubscriberExists", null, receiptId, subscriberAddress);
    }

    isValidConsent(receiptId, subscriberAddress) {
        return Web3_1_0.call(this, this.paramSubscriberManagerContract, "isValidConsent", null, receiptId, subscriberAddress);
    }


    _getSubsIdForTxnHash(txHash, resolve, reject) {
        let that = this;
        setTimeout(() => {
            that.connection.eth.getTransactionReceipt(txHash, (err, data) => {
                if (err) {
                    return reject(err)
                }
                if (data) {
                    if (data.logs && data.logs.length >= 0 && data.logs[0].topics[2]) {
                        return resolve(data.logs[0].topics[2]);
                    }
                    return reject(data);
                }
                that._getSubsIdForTxnHash(txHash, resolve, reject);
            })
        }, 1000)
    }

    /**
     * getSubscriberReceipts is an async function, using this function you can get details for a given receipt transaction details.
     * @returns {Promise} promise
     * 
     * @example
     * Usage:
     * paramSubscriberManager
     *   .getSubscriberReceipts()
     *   .then((result)=>{
     *       //TODO
     *   })
     */

    /**
     * isSubscriberExists is an async function, using this function can check is the subscriber exists.
     * If transaction is successful receipt state is CREATE_PO and step will be ACCEPT_PROPOSAL_AND_CREATE_PO state. 
     * This function will return promise function.     
     * 
     * @param {String} receiptId - Receipt Id    
     * @param {String} subscriberAddress - subscriber Address
     * @returns {Promise} promise
     * 
     * @example
     * Usage:
     * paramSubscriberManager
     *   .isSubscriberExists("<RECEIPT_ID>", {from:<FROM_PARAM_ADDRESS>})
     *   .then((result)=>{
     *       //TODO 
     *   })
     */

    /**
     * getSubscribers is an async function, using this function you can get details for a given extendedKnowledge Id.
     * @param {String} receiptId - extendedKnowledge Id
     * @returns {Promise} promise
     * 
     * @example
     * Usage:
     * paramSubscriberManager
     *   .getSubscribers("<EXTENDEDKNOWLEDGE_ID>")
     *   .then((result)=>{
     *       //TODO
     *   })
     */
    /**
     * getSubscriber is an async function, using this function you can get details for a given extendedKnowledge Id.
     * @param {String} sId - subscriber Id
     * @returns {Promise} promise
     * 
     * @example
     * Usage:
     * paramSubscriberManager
     *   .getSubscribers("<SUBSCRIBER_ID>")
     *   .then((result)=>{
     *       //TODO
     *   })
     */

    // /**                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
    //  * addSellerConsent is an async function, using this function seller will change receipt state from purchase order to invoice.
    //  * This function will return promise function.
    //  * 
    //  * @param {String} rId - Receipt Id
    //  * @param {String} receiptType - Receipt Type
    //  * @returns {Promise} promise
    //  * 
    //  * @example
    //  * Usage:
    //  * paramSubscriberManager
    //  *   .addSellerConsent("<RECEIPT_ID>", {from:<FROM_PARAM_ADDRESS>})
    //  *   .then((result)=>{
    //  *       //TODO 
    //  *   })
    //  */
    // addSellerConsent(receiptId, receiptType, options) {
    //     const promise = new Promise((resolve, reject)=>{
    //         const that = this;
    //         this.paramSubscriberManagerContract.addSellerConsent.estimateGas(receiptId, receiptType, options, function(error, _gas){
    //             if(error){
    //                 return reject(error);
    //             }
    //             _gas = parseInt(_gas*1.3);
    //             options.gas = _gas;
    //             if(options.privateKey){
    //                 let txData = that.paramSubscriberManagerContract.addSellerConsent.getData(receiptId, receiptType);
    //                 ParamUtils.submitTransaction(that.connection, txData, options).then((data) => {
    //                     resolve(data)
    //                 }).catch(error=>{
    //                     reject(error)
    //                 })
    //                 return;
    //             }
    //             that.paramSubscriberManagerContract.addSellerConsent(receiptId, receiptType, options, function(error, data){
    //                 if(error){
    //                     return reject(error);
    //                 }
    //                 resolve(data)
    //             })
    //         })
    //     });
    //     return promise;        
    // }

    // /**
    //  * addBuyerConsent is an async function, using this function seller will change receipt state from purchase order to invoice.
    //  * This function will return promise function.
    //  * 
    //  * @param {String} rId - Receipt Id
    //  * @param {String} receiptType - Receipt Type
    //  * @returns {Promise} promise
    //  * 
    //  * @example
    //  * Usage:
    //  * paramSubscriberManager
    //  *   .addBuyerConsent("<RECEIPT_ID>", {from:<FROM_PARAM_ADDRESS>})
    //  *   .then((result)=>{
    //  *       //TODO 
    //  *   })
    //  */
    // addBuyerConsent(receiptId, receiptType, options) {
    //     const promise = new Promise((resolve, reject)=>{
    //         const that = this;
    //         this.paramSubscriberManagerContract.addBuyerConsent.estimateGas(receiptId, receiptType, options, function(error, _gas){
    //             if(error){
    //                 return reject(error);
    //             }
    //             _gas = parseInt(_gas*1.3);
    //             options.gas = _gas;
    //             if(options.privateKey){
    //                 let txData = that.paramSubscriberManagerContract.addBuyerConsent.getData(receiptId, receiptType);
    //                 ParamUtils.submitTransaction(that.connection, txData, options).then((data) => {
    //                     resolve(data)
    //                 }).catch(error=>{
    //                     reject(error)
    //                 })
    //                 return;
    //             }
    //             that.paramSubscriberManagerContract.addBuyerConsent(receiptId, receiptType, options, function(error, data){
    //                 if(error){
    //                     return reject(error);
    //                 }
    //                 resolve(data)
    //             })
    //         })
    //     });
    //     return promise;
    // }    

    // /**
    //  * isValidConsent is an async function, using this function you can get details for a given extendedKnowledge Id.
    //  * @param {String} receiptId - receipt Id
    //  * @returns {Promise} promise
    //  * 
    //  * @example
    //  * Usage:
    //  * paramSubscriberManager
    //  *   .isValidConsent("<EXTENDEDKNOWLEDGE_ID>")
    //  *   .then((result)=>{
    //  *       //TODO
    //  *   })
    //  */
    // isValidConsent(receiptId) {
    //     const promise = new Promise((resolve, reject)=>{
    //         this.paramSubscriberManagerContract.isValidConsent(receiptId, function(error, data){
    //             if(error){
    //                 return reject(error);
    //             }
    //             resolve(data)
    //         })
    //     });
    //     return promise;
    // } 

    // /**
    //  * getConsentsForReceipt is an async function, using this function you can get details for a given extendedKnowledge Id.
    //  * @param {String} receiptId - extendedKnowledge Id
    //  * @returns {Promise} promise
    //  * 
    //  * @example
    //  * Usage:
    //  * paramSubscriberManager
    //  *   .getConsentsForReceipt("<RECEIPT_ID>")
    //  *   .then((result)=>{
    //  *       //TODO
    //  *   })
    //  */
    // getConsentsForReceipt(receiptId) {
    //     const promise = new Promise((resolve, reject)=>{
    //         this.paramSubscriberManagerContract.getConsentsForReceipt(receiptId, function(error, data){
    //             if(error){
    //                 return reject(error);
    //             }
    //             resolve(data)
    //         })
    //     });
    //     return promise;
    // }

    /**
     * registerOnSubscriber function is used to register live transaction updates from the param network. 
     * 
     * @example
     * Usage:
     * const transUpdate = (error, data)=>{
     *      //TODO
     *  }
     * paramSubscriberManager
     *   .registerOnSubscriber(transUpdate)
     */


    getAllEventsByReceiptId(rId) {
        let events = ["onSubscriber", "onConsent"];
        let promiseArray = [];
        let filter = {
            filter: {
                "rId": rId
            },
            fromBlock: 0,
            toBlock: 'latest'
        }

        for (let index in events) {
            let promise = Web3_1_0.getPastEvents(this, this.paramSubscriberManagerContract, events[index], filter);
            promiseArray.push(promise);
        }
        return Web3_1_0.upgradeEventsData(promiseArray, this.connection);
    }

    registerOnSubscriber(callback, options) {
        if (!this.events) {
            this.initEvents(options);
            // throw Error("Events is null. Call initEvents()");
        }
        this.events.addListener("onSubscriber", callback);
    }

    unRegisterOnSubscriber(callback) {
        if (!this.events) {
            return;
        }
        this.events.removeListener("onSubscriber", callback);
    }

    registerOnConsent(callback, options) {
        if (!this.events) {
            this.initEvents(options);
            // throw Error("Events is null. Call initEvents()");
        }
        this.events.addListener("onConsent", callback);
    }

    unRegisterOnConsent(callback) {
        if (!this.events) {
            return;
        }
        this.events.removeListener("onConsent", callback);
    }
}
export default ParamSubscriber;